import { Phone } from "lucide-react";
import { ADDRESS_LINE1, ADDRESS_LINE2, PHONE_DISPLAY, PHONE_TEL } from "@/lib/campaign";
import { track } from "@/lib/track";
import { Reveal } from "@/components/campaign/Reveal";
import { AppointmentRequest } from "@/components/campaign/AppointmentRequest";
import { BOOKING_CHOICE } from "@/lib/campaign";

export const FmRequest = ({ variant }) => (
  <section
    id="request"
    data-testid="fm-request-section"
    className="scroll-mt-20 py-16 sm:py-24 bg-[var(--brand-cream)] border-t border-[var(--brand-gold-soft)]"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-gold)]">
          Request a time with Dr. Crosson
        </p>
        <h2 className="mt-3 font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)] leading-tight">
          Pick two times that work for you.
        </h2>
        <p className="mt-4 text-lg leading-relaxed max-w-2xl">
          The office will contact you to confirm one of them. Your appointment isn&rsquo;t
          confirmed until you hear from the office. Prefer to talk?{" "}
          <a
            data-testid="fm-request-call-link"
            href={PHONE_TEL} data-call-location="request_section"
            onClick={() => track(variant, "call_click")}
            className="font-semibold text-[var(--brand-navy)] underline decoration-[var(--brand-gold)] decoration-2 underline-offset-4"
          >
            Call {PHONE_DISPLAY}
          </a>
          .
        </p>
      </Reveal>
      <div className="mt-10 grid lg:grid-cols-[1.5fr_1fr] gap-10 items-start">
        <Reveal delay={0.1}>
          <div className="bg-white border border-[var(--brand-gold-soft)] p-5 sm:p-8 shadow-sm">
            <AppointmentRequest visitType={BOOKING_CHOICE.hormone} variant={variant} />
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="relative hidden lg:block">
            <div className="absolute -inset-2 border border-[var(--brand-gold)] opacity-50" aria-hidden="true" />
            <img
              src="/images/storefront.webp"
              alt="Entrance to All-In Precision Wellness in Easton, Pennsylvania."
              className="relative w-full h-72 object-cover object-[70%_center] shadow-lg"
              loading="lazy"
            />
          </div>
          <div className="mt-8 lg:mt-10 text-base leading-relaxed">
            <p className="font-serif-brand text-xl font-medium text-[var(--brand-navy)]">
              All-In Precision Wellness
            </p>
            <p className="mt-2">
              {ADDRESS_LINE1}
              <br />
              {ADDRESS_LINE2}
            </p>
            <a
              href={PHONE_TEL} data-call-location="request_address"
              onClick={() => track(variant, "call_click")}
              className="mt-3 inline-flex items-center gap-2 font-semibold text-[var(--brand-navy)] underline decoration-[var(--brand-gold)] decoration-2 underline-offset-4"
            >
              <Phone className="h-4 w-4" aria-hidden="true" /> {PHONE_DISPLAY}
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export const FmStickyCTA = ({ variant, onRequest }) => (
  <div
    data-testid="fm-sticky-cta"
    className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-[var(--brand-gold-soft)] px-4 py-3 flex gap-3"
    style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
  >
    <button
      data-testid="fm-sticky-request-button"
      onClick={onRequest}
      className="flex-1 inline-flex items-center justify-center bg-[var(--brand-navy)] text-white font-semibold py-3 text-base"
    >
      Request Appointment
    </button>
    <a
      data-testid="fm-sticky-call-button"
      href={PHONE_TEL} data-call-location="sticky"
      onClick={() => track(variant, "call_click")}
      className="flex-1 inline-flex items-center justify-center gap-2 border-2 border-[var(--brand-navy)] text-[var(--brand-navy)] font-semibold py-3 text-base bg-white"
    >
      <Phone className="h-4 w-4" aria-hidden="true" /> Call
    </a>
  </div>
);
